/**
 * UserHub 左メニュー項目定義（AdminHub ハブ設定の ID と同期必須）
 */

export const USER_HUB_NAV_ITEM_LABELS = [
  { id: 'dashboard', label: 'ダッシュボード' },
  { id: 'modules', label: 'モジュール' },
  { id: 'licenses', label: 'ライセンス' },
  { id: 'billing', label: '決済・請求' },
  { id: 'account', label: 'アカウント' },
  { id: 'clinic', label: 'クリニック' },
  { id: 'users', label: 'ユーザー管理' },
  { id: 'integrations', label: 'アプリ連携' },
  { id: 'contact', label: 'お問い合わせ' },
  { id: 'invitation', label: '招待コード' },
  { id: 'legal', label: '規約・ポリシー' },
];

export function createDefaultNavEnvMap() {
  const map = {};
  for (const { id } of USER_HUB_NAV_ITEM_LABELS) {
    map[id] = true;
  }
  return map;
}

export function createDefaultUserHubNavVisibility() {
  return {
    prod: createDefaultNavEnvMap(),
    dev: createDefaultNavEnvMap(),
  };
}

export function normalizeNavVisibilityFromApi(raw) {
  const defaults = createDefaultUserHubNavVisibility();
  if (!raw || typeof raw !== 'object') return defaults;
  const result = { prod: { ...defaults.prod }, dev: { ...defaults.dev } };
  for (const env of ['prod', 'dev']) {
    const source = raw[env] && typeof raw[env] === 'object' ? raw[env] : {};
    for (const { id } of USER_HUB_NAV_ITEM_LABELS) {
      if (typeof source[id] === 'boolean') {
        result[env][id] = source[id];
      }
    }
  }
  return result;
}

export function countVisibleNavItems(envMap) {
  return Object.values(envMap || {}).filter((v) => v === true).length;
}
